import { observer } from 'mobx-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default observer(class VariantPrice extends Component {
  static propTypes = {
    availability: PropTypes.object.isRequired,
    priceDisplay: PropTypes.object.isRequired,
    store: PropTypes.object
  }

  render() {
    let priceText, priceUndiscountedText, priceLocalCurrency, isDiscount, saveText;
    const { availability, priceDisplay, store } = this.props;
    const { displayGross, handleTaxes } = priceDisplay;
    const variant = store.variant;
    const taxRate = availability.taxRate;
	const istaxRateDict = (typeof(taxRate) == 'object')
	let modifiedTaxRate=``;
	if (istaxRateDict) {
	Object.entries(taxRate).map(([key, val], index, arr) => {
		 if(index !== arr.length - 1) {
		 modifiedTaxRate = modifiedTaxRate+`${key}=` + val+ `%, `
		 //console.log(key, val, index,handleTaxes,displayGross,modifiedTaxRate);		 
		 }
		 else{    		 
		 modifiedTaxRate = modifiedTaxRate+`${key}=` + val+ `%`	 
		 //console.log(key, val, index,handleTaxes,displayGross,modifiedTaxRate);			 
		 }
	})

	 
	}
	else{
		modifiedTaxRate= taxRate+`% VAT`;
	}
	
    if (!store.isEmpty) {
      // variant price
      isDiscount = variant.price.gross !== variant.priceUndiscounted.gross;
      if (displayGross) {
        priceText = `${variant.price.grossLocalized}`;
        priceUndiscountedText = `${variant.priceUndiscounted.grossLocalized}`;	
        priceUndiscountedText = `${variant.priceUndiscounted.grossLocalized}`;	
        saveText = `${variant.save.grossLocalized}`;			
        if (variant.priceLocalCurrency) {
          priceLocalCurrency = variant.priceLocalCurrency.grossLocalized;
        }
      } else {
        priceText = `${variant.price.netLocalized}`;
        priceUndiscountedText = `${variant.priceUndiscounted.netLocalized}`;
        saveText = `${variant.save.netLocalized}`;			
        if (variant.priceLocalCurrency) {
          priceLocalCurrency = variant.priceLocalCurrency.netLocalized;
        }
      }
    } else {
      // if there's no variant, fall back to product price
      const { discount, priceRange, priceRangeUndiscounted, save  } = availability;
      isDiscount = discount && !!Object.keys(discount).length;
      if (displayGross) {
        priceText = `${priceRange.minPrice.grossLocalized}`;
        priceUndiscountedText = `${priceRangeUndiscounted.minPrice.grossLocalized}`;
        saveText = `${save.minPrice.grossLocalized}`;		
        if (availability.priceRangeLocalCurrency) {
          priceLocalCurrency = availability.priceRangeLocalCurrency.minPrice.grossLocalized;
        }
      } else {
        priceText = `${priceRange.minPrice.netLocalized}`;
        priceUndiscountedText = `${priceRangeUndiscounted.minPrice.netLocalized}`;	
        saveText = `${save.minPrice.netLocalized}`;		
        if (availability.priceRangeLocalCurrency) {
          priceLocalCurrency = availability.priceRangeLocalCurrency.minPrice.netLocalized;
        }
      }
    }
    return (
      <h2 className="product__info__price">
        <span>{priceText}&nbsp;</span>
        {isDiscount && (
          <small style={{color:'red'}} className="product__info__price__undiscounted">{priceUndiscountedText}</small>
        )}
        {priceLocalCurrency && (
          <p><small className="text-info">&asymp; {priceLocalCurrency}</small></p>
        )}
        {handleTaxes && [	
          displayGross ? ( <small> including {modifiedTaxRate}  </small>):(
            <small> excluding {modifiedTaxRate} </small>)
        ]}
        {isDiscount && (
          <div><strong style={{color:'blue'}} >You save {saveText}</strong> </div>
        )}		
      </h2>
    );
  }
});
